module.exports = __webpack_public_path__ + "static/media/intro_msg2.70e542a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Conviot/Intro/img/intro_msg2.png
// module id = 188
// module chunks = 0